module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/perfect/perfect-06-df7c17b7381fa7fcf6e13cb5827ab4f8.jpg";